module.exports = __webpack_public_path__ + "img/61_4.307b7a28.png";